// extracted by mini-css-extract-plugin
export var close = "popup-module--close--eOHn3";
export var content = "popup-module--content--R2pu2";
export var imageContent = "popup-module--imageContent--v5zgj";
export var open = "popup-module--open--hHIm-";
export var popup = "popup-module--popup--PibPv";
export var popupModal = "popup-module--popupModal--zxTaR";
export var prominentPopup = "popup-module--prominentPopup--plrlB";
export var sbShowMain = "popup-module--sb-show-main--UKpGs";
export var textContent = "popup-module--textContent--LgClR";
export var top = "popup-module--top--PqeSg";